import React, { useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../../request/Postrequest";
import Loader from "../../../common/Loader";
import { FETCH_CLIENT_EMPLOYEE_V2 } from "../../../constant/Apipath";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

const ClientTimesheetEmployeesModal = ({
  isOpen,
  onClose,
  setSelectedEmp,
  empList,
  setSelectEmployees
}) => {
  const [clientEmployees, setEmployeesList] = useState([]);
  const [searchEmployee, setSearchEmployee] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;

  const { TEXT_SELECT_EMPLOYEES, TEXT_SEARCH_EMPLOYEE, BUTTON_NEXT, TEXT_NO_EMPLOYEE_FOUND } =
    ClientEnglishFallback?.SelectJobEmployeesModal(
      multiLanguageData?.SelectJobEmployeesModal || {}
    );

  useEffect(() => {
    if (isOpen) {
      getEmployee();
    }
  }, [isOpen]);

  const getEmployee = async () => {
    try {
      const payload = {
        ClientId: selectedClientData?.ClientId,
        PageNumber: 1,
        NrRowsPerPage: 20,
        SearchString: ""
      };

      // const payload = {
      //   PageNr: 1,
      //   NrOfRecPerPage: 20,
      //   FullSearch: inputValue,
      //   UserId: USER_ID,
      //   IncludeRecordNr: true,
      //   FetchAllowedRecordsOnly: true,
      //   SearchList: [{ ClientId: selectedClientData?.ClientId }]
      // };
      const clientJobRes = await Postrequestcall(FETCH_CLIENT_EMPLOYEE_V2, payload, TOKEN);
      const data = clientJobRes?.data?.data || [];
      const processedEmployees = data?.map((employee) => ({
        ...employee,

        checked: empList?.filter((item) => item?.id === employee?.id).length > 0 ? true : false
      }));
      setEmployeesList(processedEmployees);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  // Memoized filtered employees
  const filteredEmployees = useMemo(() => {
    const searchTerm = searchEmployee.toLowerCase().trim();
    return clientEmployees?.filter(
      (employee) =>
        employee.firstName.toLowerCase().includes(searchTerm) ||
        employee.lastName?.toLowerCase().includes(searchTerm)
    );
  }, [clientEmployees, searchEmployee]);

  const toggleEmployeeSelection = (employeeId) => {
    setEmployeesList((prev) =>
      prev?.map((employee) =>
        employee.id === employeeId ? { ...employee, checked: !employee.checked } : employee
      )
    );
  };

  const handleAddEmployees = () => {
    let temp = [];
    clientEmployees?.map((employee) => {
      if (employee.checked) {
        temp.push({
          clientEmployeeId: employee.id,
          firstName: employee.firstName,
          lastName: employee.lastName,
          clientEmployeeUDFieldsList: employee.clientEmployeeUDFieldsList,
          userProfilePicture: employee.userProfilePicture
        });
      }
    });

    setSelectedEmp(temp);
    setSelectEmployees(false);
    setSearchEmployee("");
  };

  const handleModalClose = () => {
    onClose();
    setSearchEmployee("");
  };

  const handleSearchChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    setSearchEmployee(inputValue);
  };

  return (
    <Modal open={isOpen} onClose={handleModalClose}>
      <Box className="client-modal-responsive" sx={{ minHeight: "600px" }}>
        {isLoading ? (
          <Stack minHeight={"500px"} alignItems={"center"} justifyContent={"center"} width={"100%"}>
            <Loader />
          </Stack>
        ) : (
          <>
            <Stack flexDirection={"row"} justifyContent={"space-between"} padding={"5px 0px"}>
              <IconButton
                size="small"
                onClick={() => {
                  handleModalClose();
                }}>
                <ArrowBackIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  handleModalClose();
                }}
                style={{ padding: "4px" }}>
                <CloseIcon />
              </IconButton>
            </Stack>
            <Stack>
              <Typography variant="h6">{TEXT_SELECT_EMPLOYEES}</Typography>
            </Stack>
            <TextField
              fullWidth
              value={searchEmployee}
              size="small"
              placeholder={TEXT_SEARCH_EMPLOYEE}
              sx={{
                borderRadius: "10px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0",
                  padding: "0"
                },
                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                  border: "none"
                },
                backgroundColor: "#e4e4e4",
                marginTop: "10px"
              }}
              onChange={handleSearchChange}
            />
            <List
              dense
              sx={{
                width: "100%",
                overflow: "auto",
                gap: 1,
                display: "flex",
                flexDirection: "column",
                minHeight: "430px",
                maxHeight: "430px",
                scrollbarWidth: "none"
              }}>
              {filteredEmployees?.map((employee) => (
                <ListItem
                  key={employee.id}
                  onClick={() => toggleEmployeeSelection(employee.id)}
                  sx={{
                    padding: "5px",
                    borderRadius: "10px",
                    border: `1px solid ${employee.checked ? CLIENT_ACCENT_COLOR : "#e4e4e4"}`,
                    margin: "5px 0px"
                  }}
                  disablePadding>
                  <Checkbox
                    sx={{
                      "&.Mui-checked": {
                        color: CLIENT_ACCENT_COLOR
                      }
                    }}
                    checked={employee.checked}
                  />
                  <ListItemAvatar>
                    <Avatar
                      sizes="small"
                      alt={`${employee.firstName} ${employee.lastName}`}
                      src={employee.userProfilePicture}
                    />
                  </ListItemAvatar>
                  <Typography variant="p">{`${employee.firstName} ${employee.lastName}`}</Typography>
                </ListItem>
              ))}

              {filteredEmployees.length === 0 && (
                <Stack sx={{ textAlign: "center", justifyContent: "center", minHeight: "350px" }}>
                  <Typography variant="h5" style={{ fontSize: "18px" }}>
                    {TEXT_NO_EMPLOYEE_FOUND}
                  </Typography>
                </Stack>
              )}
            </List>
            <Button
              sx={{
                mt: 1,
                backgroundColor:
                  clientEmployees?.filter((emp) => emp.checked)?.length > 0
                    ? CLIENT_ACCENT_COLOR
                    : "lightgrey",
                color: "white"
              }}
              disabled={clientEmployees?.filter((emp) => emp.checked)?.length === 0 ? true : false}
              fullWidth
              onClick={handleAddEmployees}>
              {BUTTON_NEXT}{" "}
            </Button>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default ClientTimesheetEmployeesModal;
